import { Ng2StateDeclaration, Transition } from '@uirouter/angular';
import { LoggingService } from '../shared/services/logging/logging.service';
import { CategoriesService } from '../shared/category/categories.service';
import { Process } from '../shared';
// import * as fromAccount from '.';
import { processResolver } from '../efaact-routing/process-resolver';
import * as fromAccount from '.';

const log = new LoggingService();

export const AccountRoute: Ng2StateDeclaration = {
    // name: 'Account.**'
    name: 'account',
    url: '/account',
    // , loadChildren: () => import('./payroll-item.module').then(r => r.AccountModule)
    data: { requiresAuth: true },
    params: { process: {} },
    resolve: [
        {
            token: 'process',
            deps: [Transition, CategoriesService],
            resolveFn: processResolver
        }
    ],
    component: fromAccount.AccountContainerComponent
};
